import { EmptyState } from '@tribeplatform/react-ui-kit/EmptyState'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { T } from '../i18n/components/T.js'

export const NotificationEmptyState = () => (
  <EmptyState
    title={<T defaultMessage="Nothing here!" id="Generics.NothingHere" />}
    description={
      <T
        defaultMessage="You don’t have any notifications."
        id="Notification.List.EmptyState.Description"
      />
    }
    icon={<SvgIcon name="inbox" />}
  />
)
